import React from 'react'
import './styles.scss'

interface Props {
  data: string[]
}

export const WasDieDatenZeigen = ({ data }: Props) => (
  <div className='WasDieDatenZeigen'>
    <div className='title'>{data[0]}</div>
    {data.map((m,i) => {
     if (i===0) return null
      return <div className='entry'>{m}</div>
    })}
  </div>
)
